<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="reviewDialogrefcss" v-if="dataobj">
        <div style="display: flex; align-items: center; margin-bottom: 20px">
          <div style="flex: 1">
            装卸队：{{ dataobj.fleetName }}
          </div>
          <div style="flex: 1;">当前余额：{{dataobj.availAmount}}</div>
          <div style="flex: 1">动账调整金额：{{ dataobj.amount }}</div>
        </div>
        <div style="margin-bottom: 20px">
          类目：{{ dataobj.flowTypeName }}
        </div>
        <div style="margin-bottom: 20px">
          转账时间：{{ dataobj.transferTime }}
        </div>
        <div style="margin-bottom: 20px">
          转账记录：
          <el-image
            v-for="(item, index) in dataobj.transferImg.split(',')"
            style="width: 50px; height: 50px"
            :src="item"
            :key="index"
            :preview-src-list="[item]"
          >
          </el-image>
        </div>
        <div>备注：{{ dataobj.remark }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button type="primary" @click="onHandleSubmit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "reviewDialogref",
  props: {},
  data() {
    return {
      title: "",
      dialogVisible: false,
      type: "",
      wallet_balance_id: "",
      dataobj: "",
    };
  },
  methods: {
    onHandleSubmit() {
      if (this.type == 1) {
        this.$api.fz
          .balanceaudit({ wallet_balance_id: this.wallet_balance_id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "审核成功",
            });
            this.$emit("suc", true);
            this.onHandleClose();
          });
      } else {
        this.$api.fz
          .balancecancel({ wallet_balance_id: this.wallet_balance_id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "作废成功",
            });
            this.$emit("suc", true);
            this.onHandleClose();
          });
      }
      this.dialogVisible = false;
    },
    /**
     * 初始化
     */
    onInitData(data, type) {
      this.type = type;
         this.wallet_balance_id = data.id;
      // 
 this.$api.fz
          .balancepre({ wallet_balance_id: this.wallet_balance_id })
          .then((res) => {
           this.dataobj = res.data;
             this.dialogVisible = true;
          });




      
   
      if (this.type == 1) {
        this.title = "是否确认审核通过？";
      } else {
        this.title = "是否作废数据？";
      }
    
    },

    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.distance-style {
  width: 80%;

}
  .reviewDialogrefcss {
    font-size: 30px;
    font-weight: 700;
    padding: 50px;
    box-sizing: border-box;
  }
</style>
